<template>
  <div id="container">
    <div class="orange">
      <div class="full_layout text_blue detail">
        <section>
          <h3>{{rulesTitle}}</h3>
        </section>
      </div>
    </div>
    <div class="full_layout flex_layout_between terms_article">
      <ul class="aside_box">
<!-- 用户协议 2-->
<!-- 隐私政策 1-->
<!-- 交易规则 3-->
<!-- 竞拍规则 4-->
<!-- 用户注销协议 7-->
<!-- 官方商城 8-->
<!-- 反洗钱 9-->
<!-- 反欺诈 15-->
        <li :class="aside==2?'on':''" @click="Aside('2')">{{ $t('title.userAgreement') }}</li>
        <li :class="aside==1?'on':''" @click="Aside('1')">{{ $t('title.privacyNotice') }}</li>
        <li :class="aside==3?'on':''" @click="Aside('3')">{{$t('title.chTradingRules')}}</li>
        <li :class="aside==4?'on':''" @click="Aside('4')">{{$t('title.auctionRules')}}</li>
        <!-- <li :class="aside==5?'on':''" @click="Aside('5')">{{ $t('title.activityRule') }}</li> -->
        <li :class="aside==6?'on':''" @click="Aside('6')">{{ $t('title.settlementAgreement') }}</li>
        <li :class="aside==7?'on':''" @click="Aside('7')">{{$t('title.closingDeleting')}}</li>
        <li :class="aside==8?'on':''" @click="Aside('8')">{{ $t('title.boxesCases') }}</li>
        <li :class="aside==15?'on':''" @click="Aside('15')">{{ $t('title.antiFraud') }}</li>
        <li :class="aside==9?'on':''" @click="Aside('9')">{{ $t('title.antiMoney') }}</li>
      </ul>
      <div class="article_box" v-html="list&&list.Content" v-loading="loading">
        
      </div>
    </div>
  </div>
</template>


<script>
//从app.vue 往 Child.vue中传递信息。
export default {
  name: 'index',
  data () {
    return {
      loading:false,
      list:'',
      aside:2,
      rulesTitle:'',
     // policies:this.$enumInfo.policies,
      title:this.$t('title.rulesAPolicies')
    }
  },
  mounted() {
  },
  created(){
    this.$store.commit('SET_HEADER_TITLE',this.title);
    this.aside=this.$route.query.type?this.$route.query.type:'2';
    this.Aside(this.aside)
  },
  methods: {
    SetRulesTitle(val){
      var name=''
      switch (val){
      case '1':
        name=this.$t('title.privacyNotice')
        break
      case '2':
        name=this.$t('title.userAgreement')
        break
      case '3':
        name=this.$t('title.chTradingRules')
        break
      case '4':
        name=this.$t('title.auctionRules')
        break
      case '5':
        name=this.$t('title.activityRule')
        break
      case '6':
        name=this.$t('title.settlementAgreement')
        break
      case '7':
        name=this.$t('title.closingDeleting')
        break
      case '8':
        name=this.$t('title.boxesCases')
        break
      case '9':
        name=this.$t('title.antiMoney')
        break
      case '15':
        name=this.$t('title.antiFraud')
        break
        default:
          break
      }
      this.rulesTitle=name
    },
    Aside(val){
      this.aside=val;
      this.SetRulesTitle(val)
      this.GetAgreements()
    },
    GetAgreements(){
      let that=this
      that.loading=true;
      let data={ServiceAgreementType:this.aside,AreaId:2}
      this.$get(this.$interface.GetNewServiceAgreements,data).then(res=>{
        if(res.Result!=0){
          if(res.Data.length>0){
            this.list=res.Data[0]
          }else{
            this.list = { Content: '' }
          }
        }
        that.loading=false
      })
    }
  } 
} 
</script>

<style scoped>
@import "../../../static/css/terms.css";
.aside_box li:hover{
  text-decoration: underline;
}
/deep/ .article_box{
  word-break: break-word;
}
/deep/ .article_box h1{
  font-size: 20px;
  margin-bottom: 10px;
}
/deep/.article_box p{
  line-height: 1.5;
  padding: 0;
}
/deep/.article_box a{
      color: #5F6DAE;
    font-weight: 700;
}
/deep/ .article_box h2{
  font-size: 18px;
      line-height: 2;
  margin: 10px 0;
}
/deep/ .article_box h3{
  font-size: 16px;
  font-weight: 400;
  padding-left: 32px;
  line-height: 1.5;
    margin: 10px 0;
}
/deep/ .article_box .h3{
  padding-left: 32px;
  margin: 10px 0;
}
/deep/ .article_box h4{
  font-size: 14px;
  font-weight: 400;
  padding-left: 64px;
    margin: 10px 0;
}
/deep/ .article_box .h4{
  padding-left: 64px;
}
/deep/ .article_box .Createul{
  padding-left: 40px;
  line-height: 1.5;
  margin: 10px 0;
}
/deep/ .article_box li{
  margin: 10px 0;
}
/deep/ .article_box .Createul.h3{
  padding-left: 64px;
}
/deep/ .article_box .Createul.h4{
  padding-left: 96px;
}
/deep/ .article_box .BoxesCases h2{
  font-weight: 400;
  margin: 10px 0;
  line-height: 1.5;
  font-size: 14px;
 }
/deep/ .article_box table{
  margin: 10px 0;
  border-collapse: collapse;
}
/deep/ .article_box table th,/deep/ .article_box table td{
 padding: 5px;
}
/deep/ .article_box table th:nth-child(3){
  width: 100px;
}
/deep/ .article_box table td:nth-child(3){
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/terms/privacy.vue